<template>
  <div>
    <b-row>
      <b-col md="8"> </b-col>
      <b-col md="4">
      <div>
          <b-modal
            id="billToEdit"
            title="Bill TO"
            header-class="header-nipige-class"
            size="lg"
            centered
            hide-footer
          >
            <sbillmodel>
              <template v-slot:footer-button="data">
                <b-button
                  class="btn btn-block mt-3"
                  btn-color="primary"
                  @click="OfficeToNext(data.data)"
                  >Update</b-button
                >
              </template>
            </sbillmodel>
          </b-modal>
          <b-button
            v-b-modal.billToEdit
            class="main-navigation-button w-1 edit_button"
            variant="white"
            btn-color="primary1"
            style="margin-left: auto; display: block; margin-top: -19px; margin-right: -14px;"
          >
            <v-avatar class="ml-n2 mt-n1" size="35">
              <img src="img/Edit.png" />
            </v-avatar>
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div class="ml-2 mt-2">
      <div class="my-content">
        <!-- <b-row style="margin-top: -69px;"> -->
        <b-col md="6" style="margin-top: -60px; margin-left: -16px;">
          <h4>Bill Name :</h4>
        </b-col>
        <b-col md="4" style="margin-left: 153px; margin-top: -58px;"
          ><h5 class="text-muted ml-n5">{{ officeData }}</h5></b-col
        >
        <!-- </b-row> -->
        <b-row style="margin-top: -5px;" class="mt-n2">
          <b-col md="6" style="margin-top: -18px;">
            <h4>Catagory :</h4>
          </b-col>
          <b-col md="4" style="margin-left: 170px; margin-top: -58px;"
            ><h5 class="text-muted ml-n5">{{ billData.category }}</h5></b-col
          >
        </b-row>
        <!-- ////////////// -->
        <b-row style="margin-top: -5px;" class="mt-n2">
          <b-col md="6" style="margin-top: -17px;">
            <h4>Email :</h4>
          </b-col>
          <b-col md="6" style="margin-left: 170px; margin-top: -58px;">
            <h5
              class="text-muted ml-n5"
              v-for="item in billToData.email"
              :key="item._id"
            >
              <!-- {{ item.mailId }} -->
              {{ partnerAllData.authentication.email }}
            </h5>
          </b-col>
        </b-row>
        <!-- ///////////// -->
        <b-row style="margin-top: -5px;" class="mt-n2">
          <b-col md="6" style="margin-top: -17px;">
            <h4>Phone :</h4>
          </b-col>
          <b-col md="6" style="margin-left: 168px; margin-top: -58px;">
            <h5
              class="text-muted ml-n5"
              v-for="item in billToData.phone"
              :key="item._id"
            >
              <!-- {{ item.number }} -->
              {{ partnerAllData.authentication.phone }}
            </h5>
          </b-col>
        </b-row>
      </div>
      <!-- Mobile view start -->
      <div class="mobile-responsive">
        <b-row>
          <h4 style="margin-top: -32px;">
            Bill Name :
            <span
              class="text-muted"
              style="font-size: 14px; margin-left:15px;"
              >{{ officeData }}</span
            >
          </h4>
        </b-row>
        <b-row>
          <h4 style="margin-top: -1px;">
            Catagory :
            <span
              class="text-muted"
              style="font-size: 14px; margin-left:15px;"
              >{{ billData.category }}</span
            >
          </h4>

          <!-- <h5 class="text-muted ml-n5">{{ billData.category }}</h5> -->
        </b-row>
        <!-- ////////////// -->
        <b-row>
          <div v-for="item in billToData.email" :key="item._id">
            <h4>
              Email :
              <span class="text-muted" style="margin-left: 45px;">{{
                item.mailId
              }}</span>
            </h4>
          </div>

          <!-- <h5
              class="text-muted ml-n5"
              v-for="item in billToData.email"
              :key="item._id"
            >
              {{ item.mailId }}
            </h5> -->
          <!-- <ul>
            <li
              class="list-style ml-n3"
              style="margin-left: -7px;"
              v-for="item in billToData.email"
              :key="item._id"
            >
              {{ item.mailId }}
            </li>
          </ul> -->
        </b-row>
        <!-- ///////////// -->
        <b-row>
          <div v-for="item in billToData.phone" :key="item._id">
            <h4>
              Phone :
              <span class="text-muted" style="margin-left: 30px;">{{
                item.number
              }}</span>
            </h4>
          </div>

          <!-- <h5
              class="text-muted ml-n5"
              v-for="item in billToData.phone"
              :key="item._id"
            >
              {{ item.number }}
            </h5> -->
          <!-- <ul>
            <li
              class="list-style ml-n3"
              style="margin-left: -7px;"
              v-for="item in billToData.phone"
              :key="item._id"
            >
              {{ item.number }}
            </li>
          </ul> -->
        </b-row>
      </div>
      <!-- Mobile view end -->
    </div>
  </div>
</template>
<script>
import sbillmodel from "@/components/Partner/PartnerEdit/BillToStepper";
import { mapGetters } from "vuex";
import { getReverseGeoCode } from "@/services/geocode";

export default {
  components: {
    sbillmodel
  },
  data() {
    return {
      billToData: null
    };
  },
  props: ["billData"],
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    officeData() {
      if (this.billToData) {
        return this.billToData.officeName;
      } else {
        return null;
      }
    }
  },
  methods: {
    async OfficeToNext(data) {
      //   this.$emit("billData", data);
      console.log("bill all data", data);

      //   try {
      //     const dataVal = await getReverseGeoCode(
      //       `${data.address.street1},${data.address.city},${data.address.state},${data.address.country}`
      //     );
      //     //console.log("bill to loc", dataVal);
      //     if (dataVal.data.status === "OK") {
      //       data.address.location.coordinates = [
      //         dataVal.data.results[0].geometry.location.lng,
      //         dataVal.data.results[0].geometry.location.lat
      //       ];
      //       //console.log("bill to loc", data);
      //     }
      //   } catch (error) {}

      let payload = {
        id: this.partnerAllData._id,
        data: {
          billTo: data,
          category: data.category.value
        }
      };

      this.$store
        .dispatch("partner/updatePartner", payload)
        .then(result => {
          console.log("result : ", result);
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success"
          });
            this.$root.$emit("bv::hide::modal", "billToEdit", "#btnShow");
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error"
          });
        });
    }
  },
  created() {
    if (this.billData.bill_to.length > 0) {
      this.billToData = this.billData.bill_to[0];
    } else {
      this.billToData = this.billData.office;
    }
    console.log("this.billToData ", this.billToData);
  }
};
</script>
<style scoped>
.text-style {
  font-family: 'Lato';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  /* or 138% */

  letter-spacing: 0.15px;

  color: rgba(143, 143, 143, 0.87);
}
.list-style {
  list-style-type: none;
}

[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
}

[btn-special="primary1"] {
  border-radius: 50%;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
</style>
